import AdminSlaveAccountsTable from "components/admin/AdminSlaveAccountsTable";

const Dashboard = () => {
  return (
    <div className="mt-3">
      <AdminSlaveAccountsTable />
    </div>
  );
};

export default Dashboard;
